import React from 'react'
import { getHexColor, TwoColorIconProps } from '@/atoms/utils'

export const FacebookCircleIcon: React.FC<TwoColorIconProps> = ({
  size = 25,
  color1 = '#1877F2',
  color2 = 'white',
  className,
}) => {
  return (
    <svg
      data-testid="facebook-icon"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M20 10C20 4.47715 15.5229 0 10 0C4.47715 0 0 4.47715 0 10C0 14.9912 3.65684 19.1283 8.4375 19.8785V12.8906H5.89844V10H8.4375V7.79688C8.4375 5.29063 9.93047 3.90625 12.2146 3.90625C13.3084 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.95 6.5625 11.5625 7.3334 11.5625 8.125V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3432 19.1283 20 14.9912 20 10Z"
        fill={getHexColor(color1)}
      />
      <path
        d="M13.8926 12.8906L14.3359 10H11.5625V8.125C11.5625 7.3334 11.95 6.5625 13.1922 6.5625H14.4531V4.10156C14.4531 4.10156 13.3084 3.90625 12.2146 3.90625C9.93047 3.90625 8.4375 5.29063 8.4375 7.79688V10H5.89844V12.8906H8.4375V19.8785C9.47287 20.0405 10.5271 20.0405 11.5625 19.8785V12.8906H13.8926Z"
        fill={getHexColor(color2)}
      />
    </svg>
  )
}
